import { AttachmentUploadUrlDTO } from 'models/conversations'
import { uploadToGCWithoutLease } from 'components/common/FileAPI/fileUtils'

export type PutAttachmentResult =
  | { ok: true }
  | { ok: false, reason: 'error' | 'cancelled' | 'exception', status?: number, error?: unknown }

const httpStatusOf = (message?: string): number | undefined => {
  const match = message?.match(/HTTP (\d{3})/)
  return match ? Number(match[1]) : undefined
}

export const putAttachmentFile = (
  file: File,
  target: AttachmentUploadUrlDTO,
  signal: AbortSignal,
  onProgress: (percent: number) => void
): Promise<PutAttachmentResult> =>
  new Promise((resolve) => {
    signal.addEventListener('abort', () => resolve({ ok: false, reason: 'cancelled' }), { once: true })
    uploadToGCWithoutLease(
      file,
      { filename: file.name, signedURL: target.uploadUrl, headers: { ...target.headers } },
      signal,
      onProgress,
      () => resolve({ ok: true }),
      () => resolve({ ok: false, reason: 'cancelled' }),
      (message) => resolve({ ok: false, reason: 'error', status: httpStatusOf(message) })
    ).catch((error: unknown) => resolve({ ok: false, reason: 'exception', error }))
  })
